import { ChangeEvent, useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import {
    CaretDown,
    FadersHorizontal,
    MagnifyingGlass,
    X
} from 'phosphor-react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'antd';
import { Helmet } from 'react-helmet';

import SecSeperator from './ui/SecSeperator';
import Selects from './ui/Select';
import RangeFilterModal from './ui/RangeFilterModal';

import { ICombineReducerType } from '../redux/reducers';
import { IBrand, ICarBodyType } from '../interface/car';
import {
    getCarAvailableBrand,
    getCarAvailablsModels
} from '../redux/actions/carModelsAction';
import { $FIXME } from '../constants';
import {
    contentAccordToCurrentLang,
    formatKm,
    useOutsideClick
} from '../utils/Helper/jsHelpers';
import {
    getAvailCarColors,
    getCarBodyTypes
} from '../redux/actions/carActions';
import text_truncate from '../utils/Helper/TextTruncate';
import { useLgMediaQuery, useMediaQueryHooks } from '../utils/Hooks/MediaQuery';
import { api } from '../helpers/api';
import { getCarData } from '../redux/actions/carListingAction';

interface searchOptions {
    brand: $FIXME[];
    model: $FIXME[];
    fuelType: string;
    transmission: $FIXME[];
    bodyType: $FIXME[];
    condition: $FIXME[];
    color: $FIXME[];
    minMileage: string;
    maxMileage: string;
    minMonthlyInstallment: string;
    maxMonthlyInstallment: string;
    modelYear: $FIXME[];
    minPrice: string;
    maxPrice: string;
    search: string;
}
export const formatMoney = (n: any) => {
    return (Math.round(n * 100) / 100).toLocaleString('fr');
};

const SearchFilter = (props: any) => {
    const [brandList, setBrandList] = useState<any[]>([]);
    const [modelsList, setModelsList] = useState<any[]>([]);
    const [carManuYear, setCarYearManu] = useState<any[]>([]);
    const [visibledriven, setvisibleDriven] = useState(false);
    const [visibleMonthly, setvisibleMon] = useState(false);
    const [modelYear, setModalYear] = useState<any[]>([]);
    const [bodyTypesList, setBodyTypeList] = useState<any[]>([]);
    const [visiblePriceRange, setvisiblePriceRange] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedOptions, setSelectedOptions] = useState({
        brand: searchParams.getAll('brand') ?? [],
        model: searchParams.getAll('model') ?? [],
        fuelType: '',
        transmission: [],
        bodyType: searchParams.getAll('bodyType') ?? [],
        condition: [],
        minMileage: '',
        maxMileage: '',
        color: [],
        modelYear: [],
        minPrice: '',
        maxPrice: '',
        minMonthlyInstallment: '',
        maxMonthlyInstallment: '',
        search: searchParams.get('search') ?? ''
    } as searchOptions);

    const [showMoreFilters, setShowMoreFilters] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const carBrands = useSelector(
        (state: ICombineReducerType) => state.carBrands.carAvailableBrands
    );
    const carModels = useSelector(
        (state: ICombineReducerType) => state.carModels.carAvilableModel
    );

    const bodyTypes = useSelector(
        (state: ICombineReducerType) => state.car.availableBodyTypes
    );
    const carColors = useSelector((state: ICombineReducerType) =>
        state.car.availableCarColor.map((item, index) => {
            let color = contentAccordToCurrentLang(item);
            return {
                label: color.color,
                backgroundcolor: item.details.find((i) => i.lang === 'en')
                    ?.color,
                value: item.slug,
                _id: item.slug
            };
        })
    );
    useEffect(() => {
        getAvailCarColors(dispatch);
        if (!bodyTypes.length) {
            getCarBodyTypes(dispatch, true);
        }
    }, []);
    useEffect(() => {
        if (!firstRender.current) {
            if (
                !Object.values(selectedOptions).filter((item) => item?.length)
                    .length
            ) {
                getCarData(dispatch, {
                    sort: '-price'
                });
            }
        }
    }, [selectedOptions]);
    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSelectedOptions({
            ...selectedOptions,
            [e.target.name]: e.target.value
        });
    };

    const onSelect = (value: string, key: string) => {
        setSelectedOptions({
            ...selectedOptions,
            [key]: value
        });
    };
    useEffect(() => {
        setSelectedOptions({
            ...selectedOptions,
            brand: searchParams.getAll('brand')
        });
    }, []);

    useEffect(() => {
        if (carBrands.filter((item: $FIXME) => item).length) {
            if (carBrands.length > 0) {
                const brandsList: Array<any> = carBrands.map(
                    (items: IBrand) => ({
                        label: items.brand,
                        value: items.slug,
                        _id: items._id
                    })
                );
                setBrandList(brandsList);
            }
        }
    }, [carBrands]);

    useEffect(() => {
        if (bodyTypes?.filter((item: $FIXME) => item).length) {
            if (bodyTypes.length > 0) {
                const bodyTypesList: any[] = bodyTypes.map(
                    (item: ICarBodyType) => ({
                        label: contentAccordToCurrentLang(item).bodyType,
                        value: item.slug,
                        _id: item._id
                    })
                );
                setBodyTypeList(bodyTypesList);
            }
        }
    }, [bodyTypes]);
    function formatMoney(n: any, iscurrency = true) {
        return iscurrency
            ? t('DH') +
                  ' ' +
                  (Math.round(n * 100) / 100)
                      .toLocaleString()
                      .replaceAll(',', ' ')
            : (Math.round(n * 100) / 100).toLocaleString().replaceAll(',', ' ');
    }

    useEffect(() => {
        let years = modelYear.map((item) => {
            return {
                label: item,
                value: item,
                _id: item
            };
        });
        setCarYearManu(years);
    }, [modelYear]);
    useEffect(() => {
        api.get('/cars/get-car-years')
            .then((res) => {
                setModalYear(res.data.modelYears.map((year: string) => t('year').replace("{{X}}", year)));
            })
            .catch(() => {});
    }, []);

    const fuelsTypes = [
        { label: t('electric'), value: 'ev', _id: 1 },
        { label: t('hybrid'), value: 'hybrid', _id: 2 },
        { label: t('phev'), value: 'phev', _id: 3 },
        { label: t('diesel'), value: 'diesel', _id: 4 },
        { label: t('petrol'), value: 'petrol', _id: 5 },
        { label: t('carburant'), value: 'carburant', _id: 6 },
        { label: t('other'), value: 'other', _id: 7 }
    ];

    const transmissionTypes = [
        { label: t('manual'), value: 'manual', _id: 1 },
        { label: t('automatic'), value: 'automatic', _id: 2 }
    ];
    useEffect(() => {
        if (props.resetFilter) {
            resetFilter();
            props.setResetFilter(false);
        }
    }, [props.resetFilter]);

    const firstRender = useRef(true);

    useEffect(() => {
        if (!firstRender.current) {
            if (selectedOptions.brand.length === 0) {
                getCarAvailablsModels(dispatch);
            }
        } else {
            firstRender.current = false;
        }

        for (let i = 0; i < selectedOptions.brand.length; i++) {
            getCarAvailableBrand(dispatch, selectedOptions.brand[i]);
        }
    }, [selectedOptions.brand]);
    useEffect(() => {
        let queryParams = JSON.parse(JSON.stringify(selectedOptions));
        let params = '';
        for (let key in queryParams) {
            if (
                queryParams[key].length === 0 ||
                queryParams[key] === undefined
            ) {
                delete queryParams[key];
            } else {
                params += `&${queryParams[key]}`;
            }
        }

        setSearchParams(queryParams);
    }, [selectedOptions]);
    useEffect(() => {
        if (carModels.filter((item: $FIXME) => item).length > 0) {
            const carModelsList = carModels.map((items: $FIXME) => ({
                label: `${items.model}`,
                value: items.slug,
                _id: items._id
            }));
            setModelsList([...carModelsList]);
        }
    }, [carModels]);

    const moreFilters = () => {
        setShowMoreFilters(!showMoreFilters);
    };
    const resetFilter = () => {
        setSelectedOptions({
            brand: [],
            model: [],
            fuelType: '',
            transmission: [],
            bodyType: [],
            condition: [],
            color: [],
            modelYear: [],
            minPrice: '',
            maxPrice: '',
            search: '',
            minMileage: '',
            maxMileage: '',
            minMonthlyInstallment: '',
            maxMonthlyInstallment: ''
        });
    };

    function resetRangeFIlter() {
        setvisibleMon(false);
        setvisiblePriceRange(false);
        setvisibleDriven(false);
    }
    const refMonth = useOutsideClick(function () {
        setvisibleMon(false);
    });
    const refDriven = useOutsideClick(function () {
        setvisibleDriven(false);
    });
    const refPrice = useOutsideClick(function () {
        setvisiblePriceRange(false);
    });

    const FiltersToggle = () => {
        setOpenModal(true);
    };
    const onClose = () => {
        setOpenModal(false);
    };
    const selectedBrands = searchParams.getAll('brand').reduce(
        (acc: any, slug) =>
            brandList.find((item) => {
                return item.value === slug;
            })
                ? [
                      ...acc,
                      brandList.find((item) => {
                          return item.value === slug;
                      }).label
                  ]
                : [...acc],
        []
    );
    return (
        <>
            {/*<Helmet>*/}
            {/*    <title>{t('buyPageTitle', { ns: 'meta' })}</title>*/}
            {/*    <meta*/}
            {/*        name="description"*/}
            {/*        content={*/}
            {/*            selectedBrands.length*/}
            {/*                ? t('buyPageDescWhenBrand', {*/}
            {/*                      ns: 'meta',*/}
            {/*                      BRAND: selectedBrands?.join(', ')*/}
            {/*                  })*/}
            {/*                : t('buyPageDesc', { ns: 'meta' })*/}
            {/*        }*/}
            {/*    ></meta>*/}
            {/*</Helmet>*/}

            <div className="search-filter padding">
                <div className="search-filter-top">
                    <form>
                        <div className="input-container">
                            <MagnifyingGlass size={24} color="#8b8b8b" />
                            <input
                                value={selectedOptions.search}
                                type="search"
                                name="search"
                                placeholder={t('searchBarPlaceholder', {
                                    ns: 'hero'
                                })}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <span
                            className="more-filter"
                            onClick={
                                useLgMediaQuery()
                                    ? FiltersToggle
                                    : moreFilters
                            }
                        >
                            {useLgMediaQuery()
                                ? t('filter')
                                : t('moreFilters')}
                            <FadersHorizontal size={24} color="#8B8B8B" />
                        </span>
                    </form>
                </div>
                <div className="search-filter-bottom">
                    <div className="more-filters">
                        <Selects
                            placeholder={t('brand')}
                            options={brandList}
                            onSelect={onSelect}
                            name="brand"
                            value={selectedOptions.brand}
                            mode="multiple"
                            maxTagCount="responsive"
                            class="select-cursor"
                        />
                        <Selects
                            placeholder={t('model')}
                            options={modelsList}
                            onSelect={onSelect}
                            showSearch={true}
                            name="model"
                            value={selectedOptions.model}
                            disabled={carBrands.length === 0}
                            mode="multiple"
                            maxTagCount="responsive"
                            class="select-cursor"
                        />

                        <div className="selects-container" ref={refDriven}>
                            <div
                                className="selects input-month"
                                onClick={() => setvisibleDriven(!visibledriven)}
                            >
                                {!!selectedOptions.maxMileage ? (
                                    <span className="show-range">
                                        {selectedOptions.minMileage}-
                                        {selectedOptions.maxMileage} KM
                                        <span
                                            className="reset-icon"
                                            onClick={() => {
                                                setSelectedOptions({
                                                    ...selectedOptions,
                                                    maxMileage: '',
                                                    minMileage: ''
                                                });
                                            }}
                                        >
                                            <X size={8} color="white" />
                                        </span>
                                    </span>
                                ) : (
                                    t('mileage').charAt(0).toLocaleUpperCase() +
                                    t('mileage').slice(1)
                                )}

                                <CaretDown
                                    size={24}
                                    color="#b3b3b3"
                                    weight="bold"
                                />
                            </div>
                            <RangeFilterModal
                                showAt="right"
                                inputPrefix="KM"
                                setvisible={setvisibleDriven}
                                minValue={selectedOptions.minMileage}
                                maxValue={selectedOptions.maxMileage}
                                visible={visibledriven}
                                handleSave={(range: any) => {
                                    setSelectedOptions({
                                        ...selectedOptions,
                                        minMileage: range.min,
                                        maxMileage: range.max
                                    });
                                    resetRangeFIlter();
                                }}
                                minTitle={formatKm(0)}
                                maxTitle={formatKm(120000)}
                                defaultStep={10000}
                                defaultMin={0}
                                defaultMax={120000}
                                minInputTitle={t('minDistance')}
                                maxInputTitle={t('maxDistance')}
                                icon="/icon/dashboard.svg"
                            />
                        </div>
                    </div>
                    {showMoreFilters && (
                        <div className="more-filters">
                            <div className="selects-container" ref={refPrice}>
                                <div
                                    className="selects input-month"
                                    onClick={() => {
                                        setvisibleDriven(false);
                                        setvisibleMon(false);
                                        setvisiblePriceRange(!visiblePriceRange);
                                    }}
                                >
                                    {!!selectedOptions.maxPrice ? (
                                        <span className="show-range">
                                            {process.env.REACT_APP_DEFAULT_CURRENCY}
                                            {text_truncate(
                                                formatMoney(
                                                    selectedOptions.minPrice
                                                )?.replaceAll(/[aA-zZ]/g, ''),
                                                12,
                                                '...'
                                            )}{' '}
                                            -
                                            {text_truncate(
                                                formatMoney(
                                                    selectedOptions.maxPrice
                                                )?.replaceAll(/[aA-zZ]/g, ''),
                                                12,
                                                '...'
                                            )}{' '}
                                            <span
                                                className="reset-icon"
                                                onClick={() => {
                                                    setSelectedOptions({
                                                        ...selectedOptions,
                                                        minPrice: '',
                                                        maxPrice: ''
                                                    });
                                                }}
                                            >
                                                <X size={8} color="white" />
                                            </span>
                                        </span>
                                    ) : (
                                        t('price').charAt(0).toUpperCase() +
                                        t('price').slice(1)
                                    )}

                                    <CaretDown
                                        size={24}
                                        color="#b3b3b3"
                                        weight="bold"
                                    />
                                </div>
                                <RangeFilterModal
                                    handleSave={(range: any) => {
                                        setSelectedOptions({
                                            ...selectedOptions,
                                            minPrice: range.min,
                                            maxPrice: range.max
                                        });
                                        resetRangeFIlter();
                                    }}
                                    showAt="right"
                                    visible={visiblePriceRange}
                                    setvisible={setvisiblePriceRange}
                                    minTitle={formatMoney(5000000)}
                                    maxTitle={formatMoney(45000000)}
                                    minValue={selectedOptions.minPrice}
                                    maxValue={selectedOptions.maxPrice}
                                    defaultMin={5000000}
                                    defaultMax={45000000}
                                    defaultStep={10000}
                                    minInputTitle={t('minPrice')}
                                    maxInputTitle={t('maxPrice')}
                                    icon="/images/priceIcon.svg"
                                />
                            </div>
                            <Selects
                                options={bodyTypesList}
                                placeholder={t('bodyType')}
                                onSelect={onSelect}
                                name="bodyType"
                                value={selectedOptions.bodyType}
                                mode="multiple"
                                maxTagCount="responsive"
                                allowClear={true}
                                class="select-cursor"
                            />
                            <Selects
                                options={fuelsTypes}
                                placeholder={t('fuelType')}
                                value={selectedOptions.fuelType}
                                name="fuelType"
                                maxTagCount="responsive"
                                allowClear={true}
                                onSelect={onSelect}
                                class="select-cursor"
                            />
                            <Selects
                                options={carColors}
                                placeholder={t('color')}
                                name="color"
                                mode="multiple"
                                maxTagCount="responsive"
                                allowClear={true}
                                onSelect={onSelect}
                                value={selectedOptions.color}
                                colors
                                class="select-cursor"
                            />
                            <Selects
                                placeholder={t('transmission')}
                                options={transmissionTypes}
                                value={selectedOptions.transmission}
                                mode="multiple"
                                maxTagCount="responsive"
                                allowClear={true}
                                name="transmission"
                                onSelect={onSelect}
                                class="select-cursor"
                            />

                            <Selects
                                options={carManuYear}
                                placeholder={t('modelYear')}
                                value={selectedOptions.modelYear}
                                name="modelYear"
                                // mode="multiple"
                                maxTagCount="responsive"
                                allowClear={true}
                                onSelect={onSelect}
                                class="select-cursor"
                            />
                        </div>
                    )}
                </div>
            </div>
            {openModal && (
                <Modal
                    open={openModal}
                    onCancel={onClose}
                    centered={true}
                    footer={false}
                    zIndex={1050}
                >
                    <div className="search-filter-modal">
                        <SecSeperator className="filter-sep" />
                        <h2 className="title">{t('filter')}</h2>
                        <div className="more-filters">
                            <Selects
                                placeholder={t('brand')}
                                options={brandList}
                                onSelect={onSelect}
                                name="brand"
                                value={selectedOptions.brand}
                                mode="multiple"
                                maxTagCount="responsive"
                                class="select-cursor"
                            />
                            <Selects
                                placeholder={t('model')}
                                options={modelsList}
                                onSelect={onSelect}
                                showSearch={true}
                                name="model"
                                value={selectedOptions.model}
                                disabled={carBrands.length === 0}
                                mode="multiple"
                                maxTagCount="responsive"
                                class="select-cursor"
                            />

                            <div className="selects-container" ref={refDriven}>
                                <div
                                    className="selects input-month"
                                    onClick={() =>
                                        setvisibleDriven(!visibledriven)
                                    }
                                >
                                    {!!selectedOptions.maxMileage ? (
                                        <span className="show-range">
                                            {selectedOptions.minMileage}-
                                            {selectedOptions.maxMileage} KM
                                            <span
                                                className="reset-icon"
                                                onClick={() => {
                                                    setSelectedOptions({
                                                        ...selectedOptions,
                                                        maxMileage: '',
                                                        minMileage: ''
                                                    });
                                                }}
                                            >
                                                <X size={8} color="white" />
                                            </span>
                                        </span>
                                    ) : (
                                        t('mileage')
                                            .charAt(0)
                                            .toLocaleUpperCase() +
                                        t('mileage').slice(1)
                                    )}

                                    <span>
                                        <img
                                            src="/images/caret_down.svg"
                                            alt=""
                                        />
                                    </span>
                                </div>
                                <RangeFilterModal
                                    showAt="right"
                                    inputPrefix="KM"
                                    setvisible={setvisibleDriven}
                                    minValue={selectedOptions.minMileage}
                                    maxValue={selectedOptions.maxMileage}
                                    visible={visibledriven}
                                    handleSave={(range: any) => {
                                        setSelectedOptions({
                                            ...selectedOptions,
                                            minMileage: range.min,
                                            maxMileage: range.max
                                        });
                                        resetRangeFIlter();
                                    }}
                                    minTitle={formatKm(0)}
                                    maxTitle={formatKm(120000)}
                                    defaultMin={0}
                                    defaultMax={120000}
                                    defaultStep={10000}
                                    minInputTitle={t('minDistance')}
                                    maxInputTitle={t('maxDistance')}
                                    icon="/icon/dashboard.svg"
                                />
                            </div>

                            <div className="selects-container" ref={refPrice}>
                                <div
                                    className="selects input-month"
                                    onClick={() => {
                                        setvisibleDriven(false);
                                        setvisibleMon(false);
                                        setvisiblePriceRange(
                                            !visiblePriceRange
                                        );
                                    }}
                                >
                                    {!!selectedOptions.maxPrice ? (
                                        <span className="show-range">
                                            {process.env.REACT_APP_DEFAULT_CURRENCY}
                                            {text_truncate(
                                                formatMoney(
                                                    selectedOptions.minPrice
                                                )?.replaceAll(/[aA-zZ]/g, ''),
                                                12,
                                                '...'
                                            )}{' '}
                                            -
                                            {text_truncate(
                                                formatMoney(
                                                    selectedOptions.maxPrice
                                                )?.replaceAll(/[aA-zZ]/g, ''),
                                                12,
                                                '...'
                                            )}{' '}
                                            <span
                                                className="reset-icon"
                                                onClick={() => {
                                                    setSelectedOptions({
                                                        ...selectedOptions,
                                                        minPrice: '',
                                                        maxPrice: ''
                                                    });
                                                }}
                                            >
                                                <X size={8} color="white" />
                                            </span>
                                        </span>
                                    ) : (
                                        t('price').charAt(0).toUpperCase() +
                                        t('price').slice(1)
                                    )}
                                    <span>
                                        <img
                                            src="/images/caret_down.svg"
                                            alt=""
                                        />
                                    </span>
                                </div>
                                <RangeFilterModal
                                    handleSave={(range: any) => {
                                        setSelectedOptions({
                                            ...selectedOptions,
                                            minPrice: range.min,
                                            maxPrice: range.max
                                        });
                                        resetRangeFIlter();
                                    }}
                                    visible={visiblePriceRange}
                                    setvisible={setvisiblePriceRange}
                                    minTitle={formatMoney(5000000)}
                                    maxTitle={formatMoney(30000000)}
                                    minValue={selectedOptions.minPrice}
                                    maxValue={selectedOptions.maxPrice}
                                    defaultMin={5000000}
                                    defaultMax={30000000}
                                    defaultStep={10000}
                                    minInputTitle={t('minPrice')}
                                    maxInputTitle={t('maxPrice')}
                                    icon="/images/priceIcon.svg"
                                />
                            </div>
                        </div>
                        <div className="more-filters">
                            <Selects
                                options={bodyTypesList}
                                placeholder={t('bodyType')}
                                onSelect={onSelect}
                                name="bodyType"
                                value={selectedOptions.bodyType}
                                mode="multiple"
                                maxTagCount="responsive"
                                allowClear={true}
                                class="select-cursor"
                            ></Selects>
                            <Selects
                                options={carColors}
                                placeholder={t('color')}
                                name="color"
                                mode="multiple"
                                maxTagCount="responsive"
                                allowClear={true}
                                onSelect={onSelect}
                                value={selectedOptions.color}
                                class="select-cursor"
                            />
                            <Selects
                                placeholder={t('transmission')}
                                options={transmissionTypes}
                                value={selectedOptions.transmission}
                                mode="multiple"
                                maxTagCount="responsive"
                                allowClear={true}
                                name="transmission"
                                onSelect={onSelect}
                                class="select-cursor"
                            />

                            <Selects
                                options={carManuYear}
                                placeholder={t('modelYear')}
                                value={selectedOptions.modelYear}
                                name="modelYear"
                                // mode="multiple"
                                maxTagCount="responsive"
                                allowClear={true}
                                onSelect={onSelect}
                                class="select-cursor"
                            />
                            <Selects
                                options={fuelsTypes}
                                placeholder={t('fuelType')}
                                value={selectedOptions.fuelType}
                                name="fuelType"
                                maxTagCount="responsive"
                                allowClear={true}
                                onSelect={onSelect}
                                class="select-cursor"
                            />
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default SearchFilter;
